import {
  campaignCreationParametersSchema,
  populatedCampaignSchema,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";

export const createCampaign = {
  name: "createCampaign" as const,
  input: campaignCreationParametersSchema,
  output: populatedCampaignSchema,
};
